export default {
  mounted() {
    this.dialog = this.el.querySelector('dialog')
    this.click = event => {
      const trigger = event.target.closest('[data-context-open]')
      if (trigger) {
        this.trigger = trigger
        if (!this.dialog.open) this.dialog.showModal()
      } else if (event.target.closest('[data-context-close]')) this.dialog.close()
      else if (event.target === this.dialog) {
        const rect = this.dialog.getBoundingClientRect()
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close()
      }
    }
    this.close = () => {if (this.trigger?.isConnected) this.trigger.focus({preventScroll:true})}
    this.key = event => {if (event.key === 'Escape') event.stopPropagation()}
    this.el.addEventListener('click', this.click)
    this.dialog.addEventListener('close', this.close)
    this.dialog.addEventListener('keydown', this.key)
  },
  destroyed() {
    this.dialog.close()
    this.el.removeEventListener('click',this.click)
    this.dialog.removeEventListener('close',this.close)
    this.dialog.removeEventListener('keydown',this.key)
  }
}
